<script>
    import { onMount } from 'svelte';
    import LeftRightLayout from '../Layout/LeftRightLayout.svelte';
    import TopBottomLayout from '../Layout/TopBottomLayout.svelte';
    import Panel from '../Layout/Panel.svelte';
    import { primaryColour } from '../styles/theme.js';
    import { sgettext } from '../../i18n.js';
    import { get } from '../../utils.js';

    import {
        isEditableTemplate,
        isStrategyChange,
        isFioriGoverned,
        isMoCGoverned,
    } from './utils.js';
    import ElementDiffList from './ElementDiffList.svelte';
    import ElementVersionContent from './ElementVersionContent.svelte';
    import MultiElementFilter from './MultiElementFilter.svelte';
    import { elementTypesWithAll } from '../Workspaces/workspacesStore.js';
    import {
        diff,
        diffLoading,
        isAPM,
        readOnly,
        showFiori,
        activityVersionId,
        approvalInfo,
        fioriComplete,
        isD2Enabled,
    } from './diffStore.js';

    export let avId;
    export let d2Configured = false;
    export let listUrl = '';
    export let governanceUrl;
    export let approvalData;
    export let approvalSummaryUrl = `${PATH_PREFIX}/sw/api/builder/activityversion/{0}/approval-summary/`;
    export let sourceTemplateVersionNumber = 0;
    export let targetTemplateVersionNumber = 0;
    export let isAPMEnabled = false;

    let typesToFilter = ["ALL"]
    let selectedElementTypes = [$elementTypesWithAll.find(el => el.id === "ALL")];

    let changeTitle = sgettext('$$ELEMENT_CHANGES_VERSION$$');

    $: if (approvalData.contextualDiff) {
        changeTitle = sgettext('$$ELEMENT_CHANGES_VERSION$$');
    } else if (approvalData.diffType === 'STRATEGY') {
        changeTitle = sgettext('$$STRATEGY_ELEMENT_CHANGES_VERSION$$');
    } else if (approvalData.diffType === 'RISK') {
        changeTitle = sgettext('$$ELEMENT_CHANGES_VERSION$$');
    }

    onMount(async () =>  {
        activityVersionId.set(avId);
        isD2Enabled.set(d2Configured);
        approvalInfo.set(approvalData);
        showFiori.set(isFioriGoverned(approvalData));
        isAPM.set(isAPMEnabled);
        readOnly.set((approvalData.diffType !== 'SUMMARY' && approvalData.diffType !== 'CONTEXTUAL' && approvalData.diffType !== 'CONTROL')|| !isEditableTemplate(approvalData));

        const resp = await get(listUrl);
        diffLoading.set(false);

        var data = await resp.json();
        diff.set(data);

        if ((isFioriGoverned(approvalData) || isAPMEnabled) && isEditableTemplate(approvalData)) {
            checkFioriNumbers();
        } else {
            fioriComplete.set(true);
        }
    });

    function checkFioriNumbers() {
        var isValid = true;
        Object.keys($diff).forEach((changes) => {
            if (["added", "modified", "removed"].includes(changes)) {
                $diff[changes].forEach((change) => {
                    if (isStrategyChange(change)) {
                        if (change.governance == null || change.governance.request_number == '') {
                            isValid = false;
                        }
                    }
                });
            }
        });
        fioriComplete.set(isValid);
    }

    function handleSelectionChange(event) {
        typesToFilter = event.detail.typesToFilter;
    }

    onMount(() => {
        if (approvalData?.diffType === 'CONTROL') {
            selectedElementTypes = [$elementTypesWithAll.find((el) => el?.id === 'SAFETY')]
        }
        else if(approvalData?.diffType === 'STRATEGY') {
            selectedElementTypes = isAPMEnabled ? $elementTypesWithAll.filter((el) => ['PART', 'QUALITY', 'SAFETY'].includes(el?.id)) : $elementTypesWithAll.filter((el) => ['PART', 'QUALITY'].includes(el?.id))
        }
    });

</script>

<div class="base-layout">
  <TopBottomLayout bottomRow={false}>
    <div class="full-height" slot="top">
      <LeftRightLayout leftColumnWidth={500} padded={false}>
        <div class="full-height" slot="left">
          <Panel
            title={changeTitle}
            headerColour={primaryColour}
            collapsible={false}
            padded={true}
          >
            <div class="grid pt-2" slot="body">
              <MultiElementFilter
                on:selectionChange={handleSelectionChange}
                {selectedElementTypes}
                diffType={approvalData.diffType}
                isContextualDiff={!!approvalData?.contextualDiff}
                isAPM={isAPMEnabled}
              />
              <ElementDiffList
                loading={$diffLoading}
                on:checkFiori={checkFioriNumbers}
                {governanceUrl}
                filterBy={typesToFilter}
              />
            </div>
          </Panel>
        </div>
        <div class="full-height" slot="right">
          <ElementVersionContent
            {approvalSummaryUrl}
            showContextualFields={approvalData.contextualDiff}
            {sourceTemplateVersionNumber}
            {targetTemplateVersionNumber}
          />
        </div>
      </LeftRightLayout>
    </div>
    <div slot="bottom" />
  </TopBottomLayout>
</div>

<style>
  .base-layout {
    display: flex;
    height: 100%;
  }

  .full-height {
    height: 100%;
  }

  /* [slot='left'] {
        display: grid;
        grid-row-gap: 15px;
        grid-auto-rows: minmax(min-content, max-content);
    } */

  :global(.fa) {
    cursor: pointer;
  }
</style>
